import { Badge, Card, CardHeader, Grid } from "@material-ui/core";
import AlarmOnIcon from "@material-ui/icons/AlarmOn";
import TimerOffIcon from "@material-ui/icons/TimerOff";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import useApi from "../../../hooks/api";
import Page from "../../ui/page";
import { EsferaConfig, TotalValueConfig } from "./chart/config";
import "./dashboard.css.scss";

const TaskCard = ({ icon, tasksQty, color, label, delayed }) => {
  return (
    <Card>
      <Link
        to={{
          pathname: "/negocios",
          state: { showtasks: true },
        }}
        className="d-task-card-label"
      >
        <div className={`d-task-card ${delayed ? "delayed" : "today"}`}>
          <div className="d-task-card-icon">
            <Badge
              overlap="circle"
              showZero
              badgeContent={tasksQty}
              color={color || "primary"}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              {icon}
            </Badge>
          </div>

          <div className="d-task-card-label-area">
            <span>{label}</span>
          </div>
        </div>
      </Link>
    </Card>
  );
};

const DrawChart = ({ title, id, ...props }) => {
  return (
    <Card id={id} elevation={5}>
      <CardHeader
        title={title}
        disableTypography
        style={{ fontSize: "16px", fontWeight: "bold" }}
      />

      <div className="d-chart-container">
        <Chart {...props} />
      </div>
    </Card>
  );
};

export default () => {
  const [tasks, setTasks] = useState({ delayed: "-", today: "-" });
  const { get } = useApi();

  useEffect(() => {
    get("/v1/support/tasks_counter")
      .then((response) => {
        const { data } = response;
        setTasks({ delayed: data.delayed, today: data.today });
      })
      .catch((err) => {
        setTasks({ delayed: "x", today: "x" });
      });
  }, []);

  return (
    <Page headerProps={{ icon: "columns", title: "Painel" }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <DrawChart
            title={
              <span style={{ fontSize: "20px" }}>
                Valor total de precatórios por esfera e tribunal
              </span>
            }
            id="ente"
            options={TotalValueConfig.options}
            series={TotalValueConfig.series}
            type="bar"
            height="350px"
            width="100%"
          />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={9}>
              <DrawChart
                title={
                  <span style={{ fontSize: "20px" }}>
                    Valor total de precatórios por esfera
                  </span>
                }
                id="ramo"
                options={EsferaConfig.options}
                series={EsferaConfig.series}
                type="bar"
                height="150px"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Grid container direction="column" spacing={3}>
                <Grid item xs={12}>
                  <TaskCard
                    icon={<AlarmOnIcon style={{ fontSize: "75px" }} />}
                    label="Tarefas de hoje"
                    tasksQty={tasks.today}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TaskCard
                    delayed
                    icon={<TimerOffIcon style={{ fontSize: "75px" }} />}
                    label="Tarefas atrasadas"
                    color="secondary"
                    tasksQty={tasks.delayed}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
};
